<ng-container *ngIf="canViewCompanyEmployeePolicies">
  <section id="policy">
    <app-company-policy-list></app-company-policy-list>
  </section>
</ng-container>

<ng-container *ngIf="canViewCompanySettings">
  <section id="datetimeType">
    <app-datetime-types-list></app-datetime-types-list>
  </section>
</ng-container>

<ng-container *ngIf="canViewDatetimeProject">
  <section id="projects">
    <app-datetime-projects-list></app-datetime-projects-list>
  </section>
</ng-container>

<ng-container *ngIf="{settings: settings$ | async, employees: employees$ | async} as attendanceSettings">
  <ng-container *ngIf="canViewCompanySettings && attendanceSettings.settings && attendanceSettings.employees">
    <section id="settings">
      <app-attendance-settings [employees]="attendanceSettings.employees" [settings]="attendanceSettings.settings"></app-attendance-settings>
    </section>
  </ng-container>
  
  <ng-container *ngIf="canViewCompanySettings && attendanceSettings.settings">
    <section id="defaultSettings">
      <app-attendance-default-settings [settings]="attendanceSettings.settings"></app-attendance-default-settings>
    </section>
  </ng-container>
  
  <ng-container *ngIf="canViewCompanySettings && attendanceSettings.settings">
    <section id="overflow">
      <app-attendance-overflow-settings [settings]="attendanceSettings.settings"></app-attendance-overflow-settings>
    </section>
  </ng-container>
  
  <ng-container *ngIf="canViewCompanySettings && attendanceSettings.settings">
    <section id="absence">
      <app-absence-settings [settings]="attendanceSettings.settings"></app-absence-settings>
    </section>
  </ng-container>
  
  <ng-container *ngIf="canViewCompanySettings && attendanceSettings.settings">
    <section id="shift">
      <app-shift-settings [settings]="attendanceSettings.settings"></app-shift-settings>
    </section>
  </ng-container>
  
  <ng-container *ngIf="canViewCompanySettings && attendanceSettings.settings && attendanceSettings.employees">
    <section id="indicator">
      <app-attendance-indicator-settings [employees]="attendanceSettings.employees" [settings]="attendanceSettings.settings"></app-attendance-indicator-settings>
    </section>
  </ng-container>
  
  <ng-container *ngIf="canViewCompanySettings && attendanceSettings.settings && (availableFeatures$ | async)?.shifts && attendanceSettings.employees">
    <section id="shiftDuration">
      <app-shift-duration-setting [employees]="attendanceSettings.employees" [settings]="attendanceSettings.settings"></app-shift-duration-setting>
    </section>
  </ng-container>
  
  <ng-container *ngIf="canViewCompanySettings && attendanceSettings.settings">
    <section id="nightShiftDuration">
      <app-night-shift-duration-setting [settings]="attendanceSettings.settings"></app-night-shift-duration-setting>
    </section>
  </ng-container>
  
  <ng-container *ngIf="canViewCompanySettings && attendanceSettings.settings">
    <section id="propotionalAdjustments">
      <app-proportional-adjustments-setting [settings]="attendanceSettings.settings"></app-proportional-adjustments-setting>
    </section>
  </ng-container>
  
  <ng-container *ngIf="canViewCompanySettings && attendanceSettings.settings">
    <section id="mealVouchers">
      <app-meal-vouchers-setting [settings]="attendanceSettings.settings"></app-meal-vouchers-setting>
    </section>
  </ng-container>
</ng-container>

